import React from 'react';

export const Play = ({ className, color = '#2C313A' }) => {
  return (
    <svg
      className={`play ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="play">
        <path
          d="M18.1562 8.94492L6.9 2.05898C6.71022 1.94278 6.49287 1.87933 6.27037 1.87521C6.04788 1.87109 5.82832 1.92644 5.63438 2.03555C5.44227 2.14295 5.28225 2.29959 5.17075 2.48935C5.05926 2.67911 5.00032 2.89514 5 3.11523V16.8855C5.00145 17.2157 5.13393 17.5317 5.36833 17.7642C5.60273 17.9967 5.91986 18.1266 6.25 18.1254C6.48043 18.1253 6.70639 18.0618 6.90313 17.9418L18.1562 11.0559C18.3371 10.9456 18.4866 10.7907 18.5904 10.606C18.6941 10.4213 18.7486 10.213 18.7486 10.0012C18.7486 9.78933 18.6941 9.58106 18.5904 9.39636C18.4866 9.21165 18.3371 9.05673 18.1562 8.94648V8.94492ZM6.25 16.8707V3.12539L17.4867 10.0004L6.25 16.8707Z"
          fill={color}
          fillOpacity="0.4"
        />
      </g>
    </svg>
  );
};
